import React from 'react';

/** Muestra código MSP con prefijo estándar (ej. MSP: 1713988366). */
export function formatCodigoMspDisplay(val) {
  const s = String(val ?? '').trim();
  if (!s) return '';
  if (/^msp\s*:/i.test(s)) return s;
  return `MSP: ${s}`;
}

/**
 * Sección F — Datos del profesional de salud (formato historia clínica MSP).
 */
export default function ProfesionalSaludMsp({
  nombreApellidos = '',
  codigoMsp = '',
  firmaSello = '',
  onChange,
  readOnly = false,
  showSectionTitle = true,
}) {
  const set = (field, value) => {
    if (!onChange) return;
    const map = {
      nombre: 'profesionalNombreApellidos',
      codigo: 'profesionalRegistroMSP',
      firma: 'profesionalFirmaElectronicaNotas',
    };
    onChange({ [map[field]]: value });
  };

  const codigoDisplay = formatCodigoMspDisplay(codigoMsp);

  if (readOnly) {
    const vacio = !nombreApellidos?.trim() && !codigoMsp?.trim() && !firmaSello?.trim();
    if (vacio) {
      return (
        <div className="msp-read-prof-empty">
          <i className="bi bi-person-badge" />
          <p>Sin datos del profesional de salud registrados.</p>
        </div>
      );
    }
    return (
      <div className="msp-read-prof-cards">
        <div className="msp-read-prof-card">
          <span className="msp-read-prof-card__lbl">
            <i className="bi bi-person" /> Nombre y apellido
          </span>
          <span className="msp-read-prof-card__val">{nombreApellidos || '—'}</span>
        </div>
        <div className="msp-read-prof-card">
          <span className="msp-read-prof-card__lbl">
            <i className="bi bi-card-text" /> Código MSP
          </span>
          <span className="msp-read-prof-card__val">{codigoDisplay || '—'}</span>
        </div>
        {firmaSello?.trim() ? (
          <div className="msp-read-prof-card msp-read-prof-card--full">
            <span className="msp-read-prof-card__lbl">
              <i className="bi bi-pen" /> Firma y sello
            </span>
            <p className="msp-read-prof-card__notas">{firmaSello}</p>
          </div>
        ) : null}
      </div>
    );
  }

  return (
    <div className="msp-prof-panel">
      {showSectionTitle && (
        <div className="msp-prof-panel__header">F. Datos del profesional de salud</div>
      )}

      <div className="msp-prof-table-wrap">
        <table className="msp-prof-table" aria-label="Datos del profesional de salud">
          <tbody>
            <tr>
              <th className="msp-prof-label" scope="row">Nombre y apellido</th>
              <td className="msp-prof-value">
                {readOnly ? (
                  <span className="msp-prof-readonly">{nombreApellidos || '—'}</span>
                ) : (
                  <input
                    type="text"
                    className="msp-prof-input"
                    value={nombreApellidos}
                    onChange={(e) => set('nombre', e.target.value)}
                    placeholder="Dr. Nombre Apellido"
                    aria-label="Nombre y apellido del profesional"
                  />
                )}
              </td>
              <th className="msp-prof-label" scope="row">Código</th>
              <td className="msp-prof-value">
                {readOnly ? (
                  <span className="msp-prof-readonly">{codigoDisplay || '—'}</span>
                ) : (
                  <input
                    type="text"
                    className="msp-prof-input"
                    value={codigoMsp}
                    onChange={(e) => set('codigo', e.target.value)}
                    placeholder="MSP: número de registro"
                    aria-label="Código MSP del profesional"
                  />
                )}
              </td>
              <th className="msp-prof-label" scope="row">Firma y sello</th>
              <td className="msp-prof-value msp-prof-value--firma">
                {readOnly ? (
                  <div className="msp-prof-firma-box msp-prof-firma-box--readonly">
                    {firmaSello || <span className="text-muted">—</span>}
                  </div>
                ) : (
                  <textarea
                    className="msp-prof-firma-box"
                    rows={3}
                    value={firmaSello}
                    onChange={(e) => set('firma', e.target.value)}
                    placeholder="Espacio para firma, sello o referencia de firma electrónica"
                    aria-label="Firma y sello del profesional"
                  />
                )}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      {!readOnly && (
        <p className="msp-prof-leyenda small text-muted mb-0">
          Los datos pueden completarse automáticamente desde el perfil profesional del consultorio.
        </p>
      )}
    </div>
  );
}
